// config
import * as http from 'utils/http';
import config from 'config';

const deleteFilterView = async ({ filterView }) => {
  const endpoint = `${config.API_URL}price-negotiation/filter-views/${filterView.id}/`;
  return http._delete(endpoint);
};

export default deleteFilterView;
